import getPageName from "./getPageName";

const site = () => {
  /* Установка целей счетчиков */
  function setTargets() {
    $(".page-header__phone").click(function () {
      if (window.yaCounter100783979) {
        yaCounter100783979.reachGoal("TopPhone");
      }
    });
    $(".page-header__btn").click(function () {
      if (window.yaCounter100783979) {
        yaCounter100783979.reachGoal("HeadButton");
      }
    });
    $(".home__btn").click(function () {
      if (window.yaCounter100783979) {
        yaCounter100783979.reachGoal("TopButton");
      }
    });
  }

  /**
   * Плавный скролл
   */
  function setNavigation() {
    $("a[href^='#']:not(.employment-formats__btn):not([rel='modal:open'])").on(
      "click",
      function (e) {
        e.preventDefault();
        const targetId = this.href.split("#").pop();
        const targetElement = $(`#${targetId}`);

        if (targetElement.length) {
          $("html, body").stop().animate(
            {
              scrollTop: targetElement.offset().top,
            },
            700,
          );
        }
      },
    );
  }

  /**
   * Отслеживание страницы 404
   */
  function catchNotFound() {
    let flag = document.querySelector(".notFound");

    if (flag) {
      let ref;
      if (localStorage.referrer) {
        ref = localStorage.getItem("referrer");
      }

      let siteurl = document.location.href,
      visitParams = { NotFoundURL: { [siteurl]: { Реферер: ref } } };

      ym(100783979, "reachGoal", "404error", visitParams);
      localStorage.removeItem("referrer");
    } else {
      localStorage.setItem("referrer", document.location.href);
    }
  }

  /**
   * Запуск Видео на секции с розыгрышем
   */
  function findVideos() {
    let videos = document.querySelectorAll(".present__picture");

    for (let i = 0; i < videos.length; i++) {
      setupVideo(videos[i]);
    }
  }

  function setupVideo(video) {
    let link = video.querySelector(".present__picture-video__link"),
      button = video.querySelector(".present__picture-logo");

    video.addEventListener("click", () => {
      let id = video.dataset.id,
        iframe = createIframe(id);

      link.remove();
      button.remove();
      video.classList.remove("active");
      video.appendChild(iframe);
    });

    link.removeAttribute("href");
    video.classList.add("video--enabled");
  }

  function createIframe(id) {
    let iframe = document.createElement("iframe");

    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("allow", "autoplay");
    iframe.setAttribute("src", generateURL(id));
    iframe.classList.add("present__picture-video");

    return iframe;
  }

  function generateURL(id) {
    let query = "?rel=0&showinfo=0&autoplay=1";

    return "https://www.youtube.com/embed/" + id + query;
  }

  /**
   * В каталоге при клике на карточку переход на программу
   */
  $(document).on("click", ".tile.active", function () {
    window.location = $(this).find("a").attr("href");
  });

  /**
   * Collapse
   */
  function collapseList(wrapper, btns, collapse, icon) {
    let wrap = document.querySelector(wrapper);

    if (wrap) {
      let buttons = wrap.querySelectorAll(btns),
        blockCollapseHeights = [],
        collapseBlock = wrap?.querySelectorAll(collapse);

      buttons.forEach((item, i) => {
        blockCollapseHeights.push(collapseBlock[i].clientHeight);
        collapseBlock[i].style.height = 0;

        item.addEventListener("click", (e) => {
          e.stopImmediatePropagation();

          if (collapseBlock[i].style.height == 0 + "px") {
            collapseBlock[i].style.height = blockCollapseHeights[i] + "px";
            item.querySelector(icon).classList.add("rotate");
          } else {
            collapseBlock[i].style.height = 0;
            item.querySelector(icon).classList.remove("rotate");
          }
        });
      });
    }
  }

  /* Табы блока tools на странице реферальной программы */
  (() => {
    const buttons = document.querySelectorAll(".tools__button button");
    if (!buttons.length) return;
    const cards = document.querySelectorAll(".tools__card");

    buttons.forEach((button, index) => {
      button.addEventListener("click", () => {
        const activeButton = document.querySelector(
          ".tools__button button.is-active"
        );
        const activeCard = document.querySelector(".tools__card.is-active");
        activeButton.classList.remove("is-active");
        activeCard.classList.remove("is-active");
        button.classList.add("is-active");
        cards[index].classList.add("is-active");
      });
    });
  })();

  /* Инициализация */
  $(function () {
    setNavigation();
    catchNotFound();
    findVideos();
    setTargets();
    
    /* collapse для блоков футера */
    if (window.innerWidth <= 767) {
      collapseList(
        ".footer-item__list--1",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--2",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--3",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
      collapseList(
        ".footer-item__list--4",
        ".footer-item__list-title",
        ".footer-item__list-collapse",
        ".footer-item__list-title__icon"
      );
    }
  });  

  function setCarouselDocumentArrow(selector) {
    $(selector).owlCarousel({
      loop: true,
      dots: false,
      margin: 10,
      nav: true,
      center: true,
      responsive: {
        0: {
          items: 1,
          autoHeight: true,
          dots: true,
          nav: false,
        },
        751: {
          items: 1,
          autoHeight: false,
          dots: false,
          nav: true,
        },
      },
    });
  }
  setCarouselDocumentArrow(".owl-carousel--document");
};

export default site;
